import { AddInInstancePresModel, CommandsLoggingParamsPresModel } from '../../gen-src/preslayer/PresModels';
import { PresLayerOptionalCompatibility } from '../mappings/PresLayerOptionalCompatibility';

export const enum LogAttr {
  id = 'id',
  instanceId = 'instance-id',
  name = 'name',
  url = 'url',
  event = 'event',
}

export class CommandLogging {
  private static extensionKey = 'extension';

  public static buildLoggingParamsPresModel(pm: AddInInstancePresModel, commandName: string): CommandsLoggingParamsPresModel {
    const logParamsPm: CommandsLoggingParamsPresModel = {
      commandsLogKey: CommandLogging.extensionKey,
      commandsLogAttrs: {
        [LogAttr.id]: pm.addInId,
        [LogAttr.instanceId]: pm.addInLocatorPresModel.addInInstanceId,
        [LogAttr.name]: PresLayerOptionalCompatibility.optionalToRequiredUnsafeCast(pm.addInRegistrationPresModel).addInName,
        [LogAttr.url]: PresLayerOptionalCompatibility.optionalToRequiredUnsafeCast(pm.addInRegistrationPresModel).url,
        [LogAttr.event]: `Executing Command: ${commandName}`,
      },
    };
    return logParamsPm;
  }
}
